import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const wrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 18rem;
  padding: ${theme.remSize[25]};
`;

export const geo: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[75]};

  > *:first-child {
    flex-shrink: 0;
  }

  > *:last-child {
    flex-grow: 1;
  }
`;

export const mainAction = () => css`
  flex: 1;
`;
